import { SERVICE_LOG } from '@/constants'
import api from '@/utils/api';

/**
 * Default import syntax does not make sense for util type files.
 * Once additional methods are added, ESLint will stop error'ing.
 */
// eslint-disable-next-line import/prefer-default-export
export async function loadServiceLookupCodes() {
  const [behaviors, objectives, progressCodes, implementations, assistTypes] = await Promise.all([
    api.get(SERVICE_LOG.LOOKUP_URLS.BEHAVIOR),
    api.get(SERVICE_LOG.LOOKUP_URLS.OBJECTIVE),
    api.get(SERVICE_LOG.LOOKUP_URLS.PROGRESS),
    api.get(SERVICE_LOG.LOOKUP_URLS.IMPLEMENTATION),
    api.get(SERVICE_LOG.LOOKUP_URLS.ASSIST_TYPE)
  ]);
  return [
    behaviors.data.data,
    objectives.data.data,
    progressCodes.data.data,
    implementations.data.data,
    assistTypes.data.data
  ];
}

export function filterDisabledOptions(optionsArray, currVal) {
  const filteredOptions = [];
  optionsArray.forEach((option) => {
    if (!option.disabledFlag || option.value === currVal) {
      filteredOptions.push(option);
    }
  });
  return filteredOptions;
}



// WEBPACK FOOTER //
// ./src/utils/service-log-utils.js